// pages/OpenExternally.jsx
import React from "react";

const OpenExternally = () => {
    return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
            <h2>You're in the Instagram App</h2>
            <p style={{ color: "white" }}>
                For the full experience, please open this page in your browser.
            </p>
            <p style={{ color: "white" }}>
                Tap the <strong>•••</strong> at the top right corner, then choose{" "}
                <strong>“Open in Browser”</strong>.
            </p>
        </div>
    );
};

export default OpenExternally;
